import React, { useContext } from "react";
import "./LandingPage.css";
import { Box, Button, Container, Typography, Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import { AppContext } from "../../context/AppContext";
import { useTranslation } from "react-i18next";

const LandingPage = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const { isLoaded } = useContext(AppContext);
  const { t } = useTranslation();

  if (isLoaded) {
    return <Box>{t("message_loading")}</Box>; // Or any loading spinner component
  }

  const handleNextClick = () => {
    const currentStep = user.currentStep ?? 1;

    if (currentStep) {
      switch (currentStep) {
        case 1:
          navigate("/BarrierQuestions/0");
          break;
        case 2:
          navigate("/ScreeningResults");
          break;
        case 3:
          navigate("/IdentifiedBarriers");
          break;
        case 4:
          navigate("/ActionPlan");
          break;
        default:
          navigate("/");
          break;
      }
    }
  };

  const buttonText =
    user.currentStep && user.currentStep > 1 ? t("button_resume") : t("button_get_started");

  if (user.currentStep === null) {
    return (
      <Container>
        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="center"
          style={{ minHeight: "70vh" }}
        >
          <Box>
            <Typography variant="h2" align="center" gutterBottom>
              {t("message_loading")}
            </Typography>
          </Box>
        </Grid>
      </Container>
    );
  }

  return (
    <Container>
      <Grid
        container
        direction="column"
        justifyContent="center"
        alignItems="center"
        style={{ minHeight: "70vh" }}
      >
        <Box>
          <Typography variant="h4" align="center" gutterBottom>
            {t("landing_title")}
          </Typography>
        </Box>
        <Box mt={2}>
          <Typography variant="subtitle1" gutterBottom className="justified-left">
            {t("landing_introduction")}
          </Typography>
        </Box>
        <Box mt={3}>
          <Button variant="contained" color="primary" onClick={handleNextClick}>
            {buttonText}
          </Button>
        </Box>
      </Grid>
    </Container>
  );
};

export default LandingPage;
